import { AdapterRegistry } from '../../adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { DatabricksSink } from 'app/model/pipeline/copysink/databricks.copysink';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { TabularSinkAdapter } from './tabular.sink.adapter';
import { Activity } from 'app/model/pipeline/activity';
import { Owned } from 'app/model/base/named';
import { Model } from 'app/model/backendmodel';
import { ValueAdapter } from '../../value.adapter';
import { CopySinkAdapter } from 'app/model/adapters/activities/copysink/copysink.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(DatabricksSink),
    asynchronous: true,
    adapts: {
        type: '*',
        preCopyScript: '*',
        importSettings: {
            type: '*',
            dateFormat: '*',
            timestampFormat: '*'
        }
    }
})
export class DatabricksSinkAdapter extends CopySinkAdapter<
    DatabricksSink,
    Model.DatabricksSink
> {
    protected override async _toResource(
        model: DatabricksSink
    ): Promise<Model.DatabricksSink> {
        const result: Model.DatabricksSink = {
            type: adfModelTypeMap.databricks.copySinkType
        };
        TabularSinkAdapter.toSinkResource(model, result);
        result.importSettings = { type: adfModelTypeMap.databricks.importSettings };
        result.importSettings.dateFormat =
            ValueAdapter.toResource(model, DatabricksSink.DATE_FORMAT) || undefined;
        result.importSettings.timestampFormat =
            ValueAdapter.toResource(model, DatabricksSink.TIMESTAMP_FORMAT) || undefined;
        return result;
    }

    protected override async _toModel(
        resource: Model.DatabricksSink,
        owner: Activity
    ): Promise<DatabricksSink> {
        const result = Owned.create<DatabricksSink>(
            Metamodel.modelFor(DatabricksSink),
            owner
        );
        TabularSinkAdapter.toSinkModel(resource, result);
        const importSettings = resource.importSettings;
        if (importSettings != null) {
            ValueAdapter.toModel(result, DatabricksSink.DATE_FORMAT, importSettings.dateFormat);
            ValueAdapter.toModel(result, DatabricksSink.TIMESTAMP_FORMAT, importSettings.timestampFormat);
        }
        return result;
    }
}
